/**
 * Agent Result Panel component.
 * Displays the final result and insights from agent execution.
 */

import React from 'react';
import type { AgentResult } from '@excel-ai-studio/shared';
import { Card, CardHeader, CardPreview, Body1, Caption1 } from '@fluentui/react-components';
import { LightbulbRegular } from '@fluentui/react-icons';

interface AgentResultPanelProps {
  result: AgentResult;
}

export const AgentResultPanel: React.FC<AgentResultPanelProps> = ({ result }) => {
  const durationSeconds = (result.totalDuration / 1000).toFixed(2);

  return (
    <div className="agent-result-panel">
      <Card>
        <CardHeader
          header={<Body1 style={{ fontWeight: 600 }}>Résultat</Body1>}
          description={
            <Caption1>
              {result.success ? (
                <span style={{ color: '#107C10' }}>✓ Succès</span>
              ) : (
                <span style={{ color: '#E81123' }}>✗ Erreur</span>
              )}
              {' • '}
              {durationSeconds}s
            </Caption1>
          }
        />
        <CardPreview>
          <div className="result-content">
            <div className="result-summary">
              <Caption1 style={{ fontWeight: 600 }}>Résumé:</Caption1>
              <Caption1>{result.summary}</Caption1>
            </div>

            {result.insights.length > 0 && (
              <div className="result-insights">
                <Caption1 style={{ fontWeight: 600 }}>
                  <LightbulbRegular style={{ fontSize: '14px', marginRight: '4px' }} />
                  Insights ({result.insights.length}):
                </Caption1>
                <ul className="insights-list">
                  {result.insights.map((insight, idx) => (
                    <li key={idx}>
                      <Caption1>{insight}</Caption1>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </CardPreview>
      </Card>
    </div>
  );
};
